/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Companyname1Inputs */

const en_entity_companyname1 = /** @type {(inputs: Entity_Companyname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Name`)
};

const de_entity_companyname1 = /** @type {(inputs: Entity_Companyname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenname`)
};

/**
* | output |
* | --- |
* | "Company Name" |
*
* @param {Entity_Companyname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_companyname1 = /** @type {((inputs?: Entity_Companyname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Companyname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_companyname1(inputs)
	return de_entity_companyname1(inputs)
});
export { entity_companyname1 as "entity_companyName" }